import React from 'react';

const VGVTable = ({ color, title, type, padroes }) => {
    let somaVgv = 0;

    return (
        <table className="table table-striped table-condensed table-padroes" style={{ border: `3px solid ${color}` }}>
            <thead>
                <tr className="text-center" style={{ backgroundColor: color, color: '#fff' }}>
                    <td colSpan="2">
                        <span style={{ textTransform: 'uppercase' }}>VGV {type} Por Padrão - {title}</span>
                        <span>&nbsp; (em mil R$)</span>
                    </td>
                </tr>
                <tr className="text-center" style={{ backgroundColor: color, color: '#fff', textTransform: 'uppercase' }}>
                    <th className="text-center" style={{ color: '#fff', padding: 7 }}>Padrão</th>
                    <th className="text-center" style={{ color: '#fff', padding: 7 }}>VGV</th>
                </tr>
            </thead>
            <tbody>
                {padroes.map((p, i) => {
                    const vgv = type === 'Lançado' ? p.vgvLancado : p.vgv;
                    const vgvStr = String(vgv || '0');
                    somaVgv += Number(vgvStr.replaceAll('.', '').replaceAll(',', '.'));
                    return (
                        <tr className="text-center" key={i}>
                            <td>{p.padrao}</td>
                            <td>{vgv}</td>
                        </tr>
                    );
                })}
            </tbody>
            <tfoot>
                <tr>
                    <td>Total</td>
                    <td>{somaVgv.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }).replace('R$', '').trim()}</td>
                </tr>
            </tfoot>
        </table>
    );
};

export default VGVTable;
